import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux'

import Root from './components/Root' 
import configureStore from './store/configureStore'; 
// import Root from './plugins/sohi/components/Root' 
// import configureStore from './plugins/sohi/store/configureStore'; 

import { ThemeProvider } from '@mui/material/styles';
import Theme from './styles/Theme'

const store = configureStore();

const rootContainer = createRoot(document.getElementById('root'));

rootContainer.render( 
	<Provider store={store}>
		<ThemeProvider theme={Theme}>
			<Root />
		</ThemeProvider>
	</Provider>);


